var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { grey } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
const StyledButtonBase = styled(ButtonBase) `
    display: flex;
    flex-direction: column;
    color: ${grey[300]};
    min-width: 80px;
    height: 60px;
    margin: 0px;
    padding: 0;
    border-radius: 4px;

    &:hover,
    &:has(+ button:hover) {
        // keep light background when hovered on menu chevron button, which is next sibling
        background: rgba(237, 236, 253, 0.2);
    }
`;
const StyledMenuButton = styled(IconButton, { shouldForwardProp: (prop) => prop !== 'rotateMenuIcon' }) `
    display: flex;
    flex-direction: column;
    color: ${grey[300]};
    position: absolute;
    top: 3px;
    right: 2px;
    border-radius: 4px;
    padding: 0;

    &:hover {
        background: rgba(0, 0, 0, 0.2);
    }

    & .ClassActionBarItem-menuButtonIcon {
        transform: ${({ rotateMenuIcon }) => {
    if (rotateMenuIcon === 'up') {
        return 'rotate(0deg)';
    }
    else if (rotateMenuIcon === 'right') {
        return 'rotate(90deg)';
    }
    else if (rotateMenuIcon === 'down') {
        return 'rotate(180deg)';
    }
    else if (rotateMenuIcon === 'left') {
        return 'rotate(270deg)';
    }
    else if (typeof rotateMenuIcon === 'number') {
        return `rotate(${rotateMenuIcon}deg)`;
    }
    else {
        return '';
    }
}}
`;
const StyledLabel = styled(Typography) `
    position: relative;
    display: flex;
    margin: auto 0 2px;
    padding: 0px 2px;
    width: 100%;
    height: 24px;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 115%;
    letter-spacing: 0.1px;
`;
const StyledIconWrapper = styled(Box) `
    position: absolute;
    display: flex;
    align-items: center;
    top: 10px;
`;
const StyledBadge = styled(Badge) `
    & .MuiBadge-badge {
        top: 6px;
        right: -8px;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0.4px;

        background-color: ${({ color }) => color === 'default' && grey[800]};
    }
`;
export const ActionBarItem = (props) => {
    const { icon, onMenuClick, label, badgeContent, badgeProps, rotateMenuIcon } = props, rest = __rest(props, ["icon", "onMenuClick", "label", "badgeContent", "badgeProps", "rotateMenuIcon"]);
    const _a = badgeProps || {}, { color: badgeColor = 'default' } = _a, restBadgeProps = __rest(_a, ["color"]);
    return (_jsxs(Box, { className: 'ClassActionBarItem-root', display: 'flex', position: 'relative', children: [_jsxs(StyledButtonBase, Object.assign({ className: 'ClassActionBarItem-button', title: label }, rest, { children: [_jsx(StyledIconWrapper, { className: 'ClassActionBarItem-iconWrapper', children: _jsx(StyledBadge, Object.assign({ className: 'ClassActionBarItem-badge', badgeContent: badgeContent, color: badgeColor }, restBadgeProps, { children: icon })) }), _jsx(StyledLabel, { className: 'ClassActionBarItem-label', component: 'span', children: label })] })), onMenuClick && (_jsx(StyledMenuButton, { className: 'ClassActionBarItem-menuButton', "data-testid": 'action-item-menu', size: 'small', onClick: onMenuClick, rotateMenuIcon: rotateMenuIcon, children: _jsx(KeyboardArrowUp, { className: 'ClassActionBarItem-menuButtonIcon' }) }))] }));
};
